import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authorizationService from '../../securityUtils/authorizationService';
import { userActions } from '../../constants/user-actions';
import AuthenticationService from '../../securityUtils/AuthenticationService';
import { downloadInstruction } from '../../actions/instructions';
import { clearPlaceList } from '../../actions/place';
import { clearMunicipalityList } from '../../actions/municipality';
import { fetchLocaleFromLocalStorage } from '../../utils';
import { locale } from '../../constants/globals';
import ModalForDocumentPreview from '../Reusable/ModalForDocumentPreview';
import { controllerPath } from '../../constants/globals';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: fetchLocaleFromLocalStorage(),
      availableLocales: [locale.default, locale.lat],
      showPreview: false,
    };
  }

  showAttachmentPreview = () => {
    this.setState({ showPreview: true });
  };

  handleAttachmentPreviewClose = () => {
    this.setState({ showPreview: false });
  };

  handleLoginClick = () => {
    AuthenticationService.login();
  };

  handleLogoutClick() {
    AuthenticationService.logout();
  }

  handleCleanUpPlaces = () => {
    this.props.clearPlaceList();
  };

  handleCleanUpMunicipality = () => {
    this.props.clearMunicipalityList();
  };

  handleLocaleSwitch = (appLocale) => {
    localStorage.setItem('locale', appLocale);
    window.location.reload();
  };

  changeComboAutocomplete = (name, newValue) => {
    this.setState({
      [name]: newValue,
    });
    this.handleLocaleSwitch(newValue);
  };

  render() {
    const { t, userAllowedActions, loggedUser, gt } = this.props || {},
      { Labels, Buttons, title, titleShort } = t || {};

    const isMenuRoleAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_ROLE,
        userAllowedActions
      );

    const isMenuDecisionAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_DECISION,
        userAllowedActions
      );

    const isMenuDecisionTypeAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_DECISION_TYPE,
        userAllowedActions
      );

    const isMenuSignetExampleAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_SIGNET_EXAMPLES,
        userAllowedActions
      );

    const isMenuUserAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_USER,
        userAllowedActions
      );

    const isMenuSignetAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_SIGNET,
        userAllowedActions
      );

    const isMenuCodebooksAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_CODEBOOKS,
        userAllowedActions
      );

    const isMenuRequestsAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_REQUESTS,
        userAllowedActions
      );

    const isMenuKjsAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_KJS,
        userAllowedActions
      );

    const isMenuPlaceAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_PLACE,
        userAllowedActions
      );

    const isMenuMunicipalityAllowed =
      userAllowedActions &&
      authorizationService.isActionAllowed(
        userActions.MENU_MUNICIPALITY,
        userAllowedActions
      );

    const isUserLoggedIn = Object.keys(loggedUser?.loggedUser)?.length !== 0;

    const headerTitle = window.innerWidth > 700 ? title : titleShort;

    const langLinks = (
      <div className="lang mt-2">
        <ComboBoxAutocomplete
          data={this.state.availableLocales}
          changeValue={(newValue) =>
            this.changeComboAutocomplete('locale', newValue)
          }
          style={{ color: 'white', minWidth: '8em' }}
          text={(a) => gt.Lang[a]}
          required
          wholeObject
          updateValue={this.state.locale}
          disableClearable={true}
          variant={'standard'}
        />
      </div>
    );

    const secondHeaderLinks = (
      <ul className="textShadow">
        <li>
          <Link to="/" role="button">
            {Labels.homePage}
          </Link>
        </li>
        {isMenuRequestsAllowed ? (
          <li>
            <Link to="/requestForSignetApproval" role="button">
              {Labels.requests}
            </Link>
          </li>
        ) : (
          <li>
            <Link to="/" role="button">
              {Labels.requests}
            </Link>
          </li>
        )}

        {isMenuDecisionAllowed ? (
          <li>
            <Link to="/decision" role="button">
              {Labels.decision}
            </Link>
          </li>
        ) : (
          <li>
            <Link to="/" role="button">
              {Labels.decision}
            </Link>
          </li>
        )}
        {isMenuSignetAllowed ? (
          <li>
            <Link to="/signet" role="button">
              {Labels.signet}
            </Link>
          </li>
        ) : (
          <li>
            <Link to="/" role="button">
              {Labels.signet}
            </Link>
          </li>
        )}

        {isUserLoggedIn ? (
          isMenuCodebooksAllowed && (
            <li className="has-child">
              <Link to="#">{Labels.adminPanel}</Link>
              <ul>
                {isMenuUserAllowed && (
                  <li>
                    <Link to="/users">{Labels.users}</Link>
                  </li>
                )}
                {isMenuCodebooksAllowed && (
                  <li>
                    <Link className="inner-menu-label-style" to="#">
                      {Labels.codebooks}
                    </Link>
                    <ul>
                      {isMenuRoleAllowed && (
                        <li>
                          <Link to="/roleList">{Labels.roles}</Link>
                        </li>
                      )}
                      {isMenuKjsAllowed && (
                        <li>
                          <Link to="/usersOfPublicFunds">{Labels.kjs}</Link>
                        </li>
                      )}
                      {isMenuPlaceAllowed && (
                        <li>
                          <Link onClick={this.handleCleanUpPlaces} to="/place">
                            {Labels.place}
                          </Link>
                        </li>
                      )}
                      {isMenuMunicipalityAllowed && (
                        <li>
                          <Link
                            onClick={this.handleCleanUpMunicipality}
                            to="/municipality"
                          >
                            {Labels.municipality}
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {isMenuCodebooksAllowed && (
                  <li>
                    <Link className="inner-menu-label-style" to="#">
                      {Labels.documents}
                    </Link>
                    <ul>
                      {isMenuDecisionTypeAllowed && (
                        <li>
                          <Link to="/decisionTypeList">
                            {Labels.decisionType}
                          </Link>
                        </li>
                      )}
                      {isMenuSignetExampleAllowed && (
                        <li>
                          <Link to="/signetExampleList">
                            {Labels.elSignetPreview}
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </li>
          )
        ) : (
          <li>
            <Link to="#">{Labels.adminPanel}</Link>
          </li>
        )}
        <li>
          <Link to="#" role="button" onClick={this.showAttachmentPreview}>
            {Labels.instruction}
          </Link>
        </li>
      </ul>
    );

    const showSignInOutButton = !this.props.location?.pathname.includes(
      '/unauthorizedAccess'
    );

    const headerContent = (
      <header className="head-menu-bar">
        <div className="head-sections">
          <div className="top-bar"></div>
          <div className="mid-sep"></div>
          <div className="bot-bar"></div>
        </div>
        <div className="container col-md-11 m-auto">
          <div className="head-tabs"></div>
          <h1>
            <Link to={'/'}>{headerTitle}</Link>
          </h1>
          <Link to="#" className="mobile-handle"></Link>
          <div className="nav">
            <nav>{secondHeaderLinks}</nav>
            {langLinks}
          </div>
          {showSignInOutButton && (
            <div className="loginLogout">
              {/*  <a>Moj профил</a> */}
              <ul>
                <li className="textShadow">
                  {!isUserLoggedIn ? (
                    <Link onClick={() => this.handleLoginClick()} to="#">
                      {Buttons.signIn}
                    </Link>
                  ) : (
                    <Link onClick={() => this.handleLogoutClick()} to="#">
                      {Buttons.signOut}
                    </Link>
                  )}
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>
    );
    return (
      <Fragment>
        {headerContent}
        {this.state.showPreview && (
          <ModalForDocumentPreview
            handleClose={this.handleAttachmentPreviewClose}
            show={this.state.showPreview}
            documentName={'korisnickoUputstvo.pdf'}
            controllerReference={controllerPath.SIGNET_EXAMPLE}
            wideModal={'wide-modal'}
          />
        )}
      </Fragment>
    );
  }
}

Header.propTypes = {
  loggedUser: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    clearPlaceList: () => {
      dispatch(clearPlaceList());
    },
    clearMunicipalityList: () => {
      dispatch(clearMunicipalityList());
    },
    downloadInstruction: (messages) => dispatch(downloadInstruction(messages)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(Header, 'Header'))
);
